import useModal, { ModalProps } from '@carvana/ds-modal';
import React, { useEffect, useRef } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';
import { ModalEvents, ModalNames } from './modal-events';

type EventedModalProps = ModalProps & {
  analyticsId: ModalNames;
  children: React.ReactNode;
  isOpen: boolean;
  eventMetadata?: Record<string, any>;
};

const EventedModal = ({
  analyticsId,
  children,
  isOpen,
  eventMetadata,
  onClose,
  ...restProps
}: EventedModalProps) => {
  const { Modal, openModal, closeModal } = useModal();
  const { trackEvent } = useAnalyticsContext();
  const prevIsOpenRef = useRef<boolean>(false);

  useEffect(() => {
    const prevIsOpen = prevIsOpenRef.current;
    prevIsOpenRef.current = isOpen;

    if (isOpen && !prevIsOpen) {
      openModal();
      trackEvent(ModalEvents.Opened, { modal: analyticsId, ...eventMetadata });
    } else if (!isOpen && prevIsOpen) {
      trackEvent(ModalEvents.Closed, { modal: analyticsId });
      closeModal();
    }
  }, [isOpen, openModal, closeModal, trackEvent, analyticsId, eventMetadata]);

  return (
    <Modal onClose={onClose} {...restProps}>
      {children}
    </Modal>
  );
};

export default EventedModal;
